(function(){
 'use strict';
 const motionSelector='.announcement-message,.campaign-copy,.feature-banner>div,.ref-brand-banner>div,.welcome-claim,.button,.ref-support>a,.footer-whatsapp,.order-share-primary,.order-share-secondary,.direct-wa,#direct-order,.ref-sticky-buy,.complete-order,.home-selection-all,.store-gallery-shop,.floating-wa,.tracking-submit,.tracking-help>a';
 const controlSelector='a,button,summary,.breadcrumb,.swipe-hint,.trust-symbol';
 const arrows=/[\u2190-\u21ff\u27a1\u2b05-\u2b07\u2794\u279c-\u27a0\u2039\u203a\u00ab\u00bb\u25b6\u25c0]\ufe0f?/g;
 let sequence=0;
 const touchDevice=matchMedia('(pointer:coarse), (prefers-reduced-motion:reduce)').matches;
 const observer=!touchDevice&&'IntersectionObserver' in window?new IntersectionObserver(entries=>{
  for(const entry of entries)entry.target.classList.toggle('mania-in-view',entry.isIntersecting);
 },{threshold:.1}):null;
 function clean(control){
  if(control.closest('script,style,textarea,input,[contenteditable="true"]'))return;
  const walker=document.createTreeWalker(control,NodeFilter.SHOW_TEXT);
  let node;
  while((node=walker.nextNode())){
   if(node.parentElement.closest('script,style,textarea,input,svg,[contenteditable="true"]'))continue;
   const before=node.nodeValue,after=before.replace(arrows,'');
   if(before!==after)node.nodeValue=after.trim()?after:after.replace(/\s+/g,'');
  }
  if(control.matches('button,a')&&!control.textContent.trim()&&!control.querySelector('svg,img')){
   const label=control.getAttribute('aria-label');
   if(label&&/(precedente|successiv)/i.test(label)){
    control.textContent=/precedente/i.test(label)?'Precedente':'Successiva';
    control.classList.add('mania-nav-label');
   }
  }
 }
 function scan(root){
  if(!(root instanceof Element))return;
  const controls=[...(root.matches(controlSelector)?[root]:[]),...root.querySelectorAll(controlSelector)];
  controls.forEach(clean);
  if(touchDevice)return;
  const motion=[...(root.matches(motionSelector)?[root]:[]),...root.querySelectorAll(motionSelector)];
  motion.forEach(el=>{
   if(el.closest('#mania-cookie-banner')||el.classList.contains('mania-motion')||el.parentElement.closest(motionSelector))return;
   el.classList.add('mania-motion');
   el.style.setProperty('--mania-delay',((sequence++%5)*.35)+'s');
   if(observer)observer.observe(el);else el.classList.add('mania-in-view');
  });
 }
 scan(document.body);
 const changes=new MutationObserver(records=>{
  const roots=new Set();
  records.forEach(record=>{
   if(record.type==='characterData'){
    const control=record.target.parentElement?.closest(controlSelector);
    if(control)roots.add(control);
   }else{
    record.addedNodes.forEach(node=>{
     if(node.nodeType===Node.ELEMENT_NODE)roots.add(node);
     else if(node.nodeType===Node.TEXT_NODE){const control=node.parentElement?.closest(controlSelector);if(control)roots.add(control);}
    });
    if(observer)record.removedNodes.forEach(node=>{
     if(node.nodeType!==Node.ELEMENT_NODE||node.isConnected)return;
     if(node.matches('.mania-motion'))observer.unobserve(node);
     node.querySelectorAll('.mania-motion').forEach(el=>observer.unobserve(el));
    });
   }
  });
  roots.forEach(root=>{if(root.isConnected)scan(root);});
 });
 changes.observe(document.body,{childList:true,subtree:true});
 function visibility(){document.body.classList.toggle('mania-page-hidden',document.hidden);}
 document.addEventListener('visibilitychange',visibility);
 visibility();
})();

